import { render, staticRenderFns } from "./studyListModal.vue?vue&type=template&id=1b0907e8&scoped=true&"
import script from "./studyListModal.vue?vue&type=script&lang=js&"
export * from "./studyListModal.vue?vue&type=script&lang=js&"
import style0 from "./studyListModal.vue?vue&type=style&index=0&id=1b0907e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0907e8",
  null
  
)

export default component.exports